import { useContext, useEffect } from 'react'
// import * as helpers from './helpers'
import QuizContext from '../QuizContext'
// import { saveProgress } from '@brainstud/react-tbl/features/account/store'

/* -------------------------------------------------- */

export const useSetQuestions = (props, questions) => {
  const quiz = useContext(QuizContext)

  useEffect(() => {
    quiz.dispatch({
      type: 'SET_QUESTIONS',
      payload: questions,
    })

    quiz.dispatch({
      type: 'SET_QUIZ',
      payload: {
        ...props,
      }
    })
  }, [])
}

/* -------------------------------------------------- */

export const useSetDefaultProgress = () => {
  const quiz = useContext(QuizContext)

  useEffect(() => {
    const questions = quiz.state.questions
    const total = questions.allIds.length

    if (total) {
      const totalPoints = Object.values(questions.byId).reduce((a, q) => a + q.points, 0)
      const progress = {
        location: 'intro',
        question: null,
        currentScore: 0,
        totalPoints: totalPoints,
        totalQuestions: total,
        remainingToView: total,
        remainingToTouch: total,
        remainingToSubmit: total,
      }

      quiz.dispatch({
        type: 'SET_PROGRESS',
        payload: {
          id: 'quiz',
          data: progress,
        }
      })

      quiz.dispatch({ type: 'LOADED' })
    }
  }, [quiz.state.questions])
}

/* -------------------------------------------------- */

export const useLoadProgress = () => {
  const quiz = useContext(QuizContext)

  useEffect(() => {
    quiz.dispatch({
      type: 'LOAD_PROGRESS',
      payload: quiz.loadedData,
    })
  }, [quiz.loadedData])
}

// export const loadProgressSuccess = payload => {
//   return { type: 'QUIZ_LOAD_PROGRESS_SUCCESS', payload }
// }

// export const loadProgress = data => {
//   return (dispatch, getState) => {
//     dispatch(loadProgressSuccess(data))
//   }
// }

/* -------------------------------------------------- */

export const useSetProgress = (anyId, data, condition, cleanUp) => {
  const quiz = useContext(QuizContext)

  useEffect(() => {
    quiz.dispatch({
      type: 'SET_PROGRESS',
      payload: {
        id: anyId,
        data,
      }
    })

    if (cleanUp) return () => {
      quiz.dispatch({
        type: 'SET_PROGRESS',
        payload: {
          id: anyId,
          data: cleanUp,
        }
      })
    }
  }, condition)
}

// export const setProgressSuccess = payload => {
//   return { type: 'SET_PROGRESS', payload }
// }
//
// export const setProgress = (anyId, progress) => {
//   return setProgressSuccess({
//     id: anyId,
//     progress,
//   })

// return (dispatch, getState) => {
// dispatch(setProgressSuccess({ id: anyId, progress }))
// dispatch(saveProgress())
// }
// }

/* -------------------------------------------------- */

// export const updateProgressSuccess = payload => {
//   return { type: 'QUIZ_UPDATE_PROGRESS_SUCCESS', payload }
// }

// export const updateProgress = quizId => {
//   return (dispatch, getState) => {
//     const { quizes } = getState()

//     const quiz = quizes.quizes.byId[quizId]
//     const quizProgress = quizes.progress[quizId] || {}

//     let viewed = 0
//     let touched = 0
//     let submited = 0
//     let points = 0

//     quiz.questions.forEach(q => {
//       const progress = quizes.progress[q] || {}

//       if(progress.points) points+=progress.points
//       if(progress.viewed) viewed++
//       if(progress.touched) touched++
//       if(progress.submited) submited++
//     })

//     const progress = {
//       passed: points >= quiz.scoreToPass,
//       currentScore: points,
//       remainingToView: quizProgress.totalQuestions - viewed,
//       remainingToTouch: quizProgress.totalQuestions - touched,
//       remainingToSubmit: quizProgress.totalQuestions - submited,
//     }

//     dispatch(updateProgressSuccess({ id: quizId, progress }))
//     // dispatch(saveProgress())
//   }
// }

/* -------------------------------------------------- */

export const useViewQuestion = qId => {
  useSetProgress(qId, {
    viewed: true,
  }, [qId])
}

// export const viewQuestion = qId => {
//   return (dispatch, getState) => {
//     console.log('viewQW', qId)
//     // const { quizes } = getState()
//     // const question = quizes.questions.byId[qId]
//     //
//     // dispatch(setProgress(question.quizId, {
//     //   location: 'question',
//     //   question: qId,
//     // }))
//     //
//     // dispatch(setProgress(qId, {
//     //   viewed: true,
//     // }))
//     //
//     // dispatch(updateProgress(question.quizId))
//   }
// }

export const useTouchQuestion = (dispatch, qId, data, callback) => {
  dispatch({
    type: 'SET_PROGRESS',
    payload: {
      id: qId,
      data: {
        ...data,
        touched: true,
      },
      callback,
    }
  })
}

// export const touchQuestion = (qId, data) => {
//   return (dispatch, getState) => {
//     const { quizes } = getState()
//     const question = quizes.questions.byId[qId]

//     dispatch(setProgress(qId, {
//       ...data,
//       touched: true,
//     }))

//     dispatch(updateProgress(question.quizId))
//   }
// }

export const useSubmitQuestion = (dispatch, qId) => {
  dispatch({
    type: 'SUBMIT_QUESTION',
    payload: qId,
  })
}

// export const submitQuestion = qId => {
//   return (dispatch, getState) => {
//     const { quizes } = getState()

//     const question = quizes.questions.byId[qId]
//     const answersAll = quizes.answers.byId
//     const progressAll = quizes.progress
//     const progress = progressAll[question.id] || {}

//     const real = helpers.getCorrectAnswers(question.answers, answersAll)
//     const picked = [].concat(progress.answer)
//     const status = helpers.compareAnswers(question.type, real, picked)
//     const points = helpers.getPoints(question.type, status, question.points)

//     dispatch(setProgressSuccess({
//       id: question.id,
//       progress: {
//         submited: true,
//         passed: points >= question.points,
//         points: points,
//       }
//     }))

//     dispatch(updateProgress(question.quizId))
//   }
// }

/* -------------------------------------------------- */

export const useSubmitQuestions = (dispatch, callback) => {
  dispatch({ type: 'SUBMIT_QUESTIONS', payload: callback })
}

// export const submitQuestions = quizId => {
//   return (dispatch, getState) => {
//     const { quizes } = getState()

//     const questions = quizes.questions.byId
//     const quiz = quizes.quizes.byId[quizId]

//     quiz.questions.forEach(q => dispatch(submitQuestion(questions[q].id)))

//     dispatch(setProgress(quizId, {
//       completed: true,
//     }))
//   }
// }

/* -------------------------------------------------- */

export const useRestartQuiz = (dispatch, callback) => {
  dispatch({
    type: 'RESTART_QUIZ',
    payload: callback,
  })
}

/* -------------------------------------------------- */